import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SaveResponse } from '../interfaces/form-model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FormDiscountCodeService {

  constructor(private http: HttpClient) { }

  addDiscountCode(id: string, discountCode: string): Observable<SaveResponse> {

    const body = {
      discount_code: discountCode
    }

    return this.http.put<SaveResponse>(`${window.location.origin}/ui-forms/v1/form/submit/${id}/discountCode`, body);
  }

  removeDiscountCode(id: string): Observable<SaveResponse> {

    return this.http.put<SaveResponse>(`${window.location.origin}/ui-forms/v1/form/submit/${id}/discountCode`, {});
  }
}
